export default {
  ArPrjCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
